import { PopupTypes, PopupStates } from '../components/Popup/Enums';

const defaultState = {
    activeType: PopupTypes.NONE,
    state: PopupStates.DEFAULT,
    properties: {}
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'POPUP_OPEN': {
            const { payload } = action;

            let newProperties = payload.properties;
            if(newProperties === undefined || newProperties === null) {
                newProperties = {};
            }

            return {
                ...state,
                activeType: payload.type,
                state: payload.state,
                properties: newProperties
            };
        }
        case 'POPUP_UPDATE_PROPS': {
            const { payload } = action;
            const { type } = payload;

            if(type !== state.activeType) {
                return state;
            }

            return {
                ...state,
                properties: payload.properties
            };
        }
        case 'POPUP_CLOSE_ACTIVE': {
            return {
                ...state,
                activeType: PopupTypes.NONE
            
            };
        }
        default: {
            return state;
        }
    }
}
